export default __webpack_public_path__ + "static/media/favicon.8164aa89.ico";